(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const slides = [...section.querySelectorAll('[data-slide]')];
      section.querySelectorAll('[data-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
        slides.forEach(slide => { slide.hidden = slide.dataset.slide !== thumb.dataset.thumb; });
        section.querySelectorAll('[data-thumb]').forEach(t => t.setAttribute('aria-pressed', String(t === thumb)));
      }));
      const form = section.querySelector('.product-form');
      if (!form) return;
      const select = form.querySelector('[data-variant-select]');
      const qty = form.querySelector('[name="quantity"]');
      const buttons = [...section.querySelectorAll('[data-purchase]')];
      const status = form.querySelector('[data-form-status]');
      let busy = false;
      function updateVariant() {
        if (!select) return;
        const option = select.selectedOptions[0];
        section.querySelectorAll('[data-price-display]').forEach(el => el.textContent = option.dataset.price);
        const compare = section.querySelector('[data-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        buttons.forEach(button => button.disabled = busy || option.dataset.available !== 'true');
        const availability = section.querySelector('[data-availability]');
        availability.textContent = option.dataset.available === 'true' ? section.dataset.available : section.dataset.sold;
        qty.min = option.dataset.min || 1;
        qty.step = option.dataset.step || 1;
        if (option.dataset.max) qty.max = option.dataset.max; else qty.removeAttribute('max');
        qty.value = qty.min;
        status.textContent = '';
      }
      if (select) select.addEventListener('change', updateVariant);
      form.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
        if (button.dataset.quantity === 'plus') qty.stepUp(); else qty.stepDown();
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      form.addEventListener('submit', async event => {
        const trigger = event.submitter;
        // Leave accelerated payment controls to Shopify.
        if (trigger && !trigger.matches('[data-purchase]')) return;
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        const selected = select?.selectedOptions[0];
        if (selected && selected.dataset.available !== 'true') return;
        const buyNow = trigger?.dataset.purchase === 'buy';
        busy = true;
        const previous = buttons.map(b => b.disabled);
        buttons.forEach(b => b.disabled = true);
        status.classList.remove('error');
        status.textContent = section.dataset.busy;
        const data = new FormData(form);
        data.delete('return_to');
        const controls = [...form.querySelectorAll('select, input[name="quantity"], [data-quantity]')];
        controls.forEach(control => control.disabled = true);
        try {
          const response = await fetch(section.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : section.dataset.error);
          if (buyNow) { window.location.assign(section.dataset.checkoutUrl); return; }
          status.textContent = section.dataset.added;
          form.querySelector('[data-view-cart]').hidden = false;
          try {
            const cartResponse = await fetch(section.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
            }
          } catch (_) { /* Successful addition remains successful if badge refresh fails. */ }
        } catch (error) {
          status.classList.add('error');
          status.textContent = error.message || section.dataset.error;
        } finally {
          busy = false;
          controls.forEach(control => control.disabled = false);
          buttons.forEach((button, i) => button.disabled = previous[i]);
        }
      });
      const sticky = section.querySelector('[data-sticky-buy]');
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const beforeForm = entries[0].boundingClientRect.top > 0;
          sticky.classList.toggle('visible', !entries[0].isIntersecting);
          sticky.querySelector('[data-sticky-options]').hidden = !beforeForm;
          sticky.querySelector('[data-purchase]').hidden = beforeForm;
        }, { threshold: 0 });
        observer.observe(form);
        section._glowriffObserver = observer;
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-section]').forEach(section => section._glowriffObserver?.disconnect()));
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();


